import AddLocationIcon from "@mui/icons-material/AddLocation";
import CloseIcon from "@mui/icons-material/Close";
import { Fab, Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { useTranslation } from "react-i18next";
import { setActiveCesiumTool } from "~/redux/reducers/mapReducer";
import { useAppDispatch, useAppSelector } from "~/redux/store/store";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.contrastText,
  },
}));

export const GeopickingButton = (): JSX.Element => {
  const classes = useStyles();
  const { t } = useTranslation("cesium");
  const dispatch = useAppDispatch();
  const activeTool = useAppSelector((s) => s.map.activeCesiumTool);
  return activeTool === "geopicking" ? (
    <Tooltip title={t("general:cancel").toString()}>
      <Fab
        size="small"
        color="primary"
        onClick={() => {
          dispatch(setActiveCesiumTool(undefined));
        }}
      >
        <CloseIcon className={classes.icon} />
      </Fab>
    </Tooltip>
  ) : (
    <Tooltip title={t("geopicking").toString()}>
      <Fab
        size="small"
        color="primary"
        onClick={() => {
          dispatch(setActiveCesiumTool("geopicking"));
        }}
      >
        <AddLocationIcon className={classes.icon} />
      </Fab>
    </Tooltip>
  );
};
